import { __extends, __rest } from "tslib";
import { BaseAppEssentials, BasePlatformEssentials, } from '@wix/fe-essentials-common';
import Experiments from '@wix/wix-experiments';
import { factory as biLoggerFactory } from '@wix/web-bi-logger/dist/src/logger';
import * as fedopsLogger from '@wix/fedops-logger';
export * from './types';
/**
 * Essentials for the Viewer platform
 */
var ViewerPlatformEssentials = /** @class */ (function (_super) {
    __extends(ViewerPlatformEssentials, _super);
    function ViewerPlatformEssentials(_a) {
        var Sentry = _a.Sentry, env = __rest(_a, ["Sentry"]);
        var _this = _super.call(this, env, new Experiments()) || this;
        /**
         * A Fedops Logger factory
         */
        _this.createFedopsLogger = fedopsLogger.create;
        /**
         * A bi Logger and Factory for more loggers
         */
        _this.biLoggerFactory = biLoggerFactory;
        _this.sentry = Sentry;
        return _this;
    }
    /**
     * Method for creating Essentials for an App
     * @param env
     */
    ViewerPlatformEssentials.prototype.createAppEssentials = function (env) {
        return new AppEssentials(env, this);
    };
    /**
     * Method for creating Essentials for a Controller
     * @param env
     */
    ViewerPlatformEssentials.prototype.createControllerEssentials = function (env, appEssentials) {
        return new ControllerEssentials(env, appEssentials);
    };
    return ViewerPlatformEssentials;
}(BasePlatformEssentials));
export { ViewerPlatformEssentials };
/**
 * Essentials for Apps within the Viewer platform
 */
var AppEssentials = /** @class */ (function (_super) {
    __extends(AppEssentials, _super);
    function AppEssentials(env, essentials) {
        var _this = _super.call(this, env, essentials) || this;
        _this.essentials = essentials;
        /**
         * A bi Logger and Factory for more loggers
         */
        _this.biLoggerFactory = biLoggerFactory;
        /**
         * A Fedops Logger factory
         */
        _this.createFedopsLogger = fedopsLogger.create;
        _this.experiments = new Experiments();
        return _this;
    }
    return AppEssentials;
}(BaseAppEssentials));
export { AppEssentials };
/**
 * Essentials for Controllers within the Viewer platform
 */
var ControllerEssentials = /** @class */ (function () {
    function ControllerEssentials(_env, appEssentials) {
        this.appEssentials = appEssentials;
        /**
         * A bi Logger and Factory for more loggers
         */
        this.biLoggerFactory = biLoggerFactory;
        /**
         * Experiments instance for the App, filtered by AppDefId
         */
        this.experiments = this.appEssentials.experiments;
        /**
         * A Fedops Logger factory
         */
        this.createFedopsLogger = this.appEssentials.createFedopsLogger;
    }
    return ControllerEssentials;
}());
export { ControllerEssentials };
//# sourceMappingURL=api.js.map